import styled from 'styled-components'

import {
  deepPurple,
  greyBlue,
  linkNavyBlue,
  paleBlue,
  white
} from '../../../styles/settings/colors'

import rem from '../../../styles/tools/rem'
import media from '../../../styles/tools/media'

export const AppIcon = 'height: 38px; width: 110px; margin: 17px 20px 0 0;'

export const AppsLinkContainer = styled.div`
  display: flex;
`

export const CardsContainer = styled.div`
  align-items: center;
  background-color: ${deepPurple};
  color: ${greyBlue};
  display: flex;
  font-size: ${rem('12px')};
  justify-content: space-between;
  letter-spacing: ${rem('0.8px')};
  padding: 30px 160px;
  ${media.small`
      flex-direction: column-reverse;
      padding: 30px 50px;
  `};
`

export const CardFlag = 'height: 30px; width: 50px; margin-right: 10px'

export const CardsFlags = styled.div`
  display: flex;
`

export const FooterContainer = styled.div`
  font-family: 'OpenSans';
  overflow: hidden;
  width: 100%;
`

export const FooterNavigation = styled.div`
  align-items: center;
  background-color: ${linkNavyBlue};
  color: ${paleBlue};
  display: flex;
  justify-content: space-between;
  padding: 50px 160px;
`

export const LogoSocial = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-right: 80px;
`

export const NavigationLink = styled.a`
  cursor: pointer;
  font-size: ${rem('12px')};
  font-weight: 600;
  letter-spacing: ${rem('0.8px')};
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const NavigationBottomItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;

  ${NavigationLink} {
    margin-bottom: 0;
  }
`

export const NavigationColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 240px;
`

export const NavigationContent = styled.div`
  display: flex;
  justify-content: space-between;
`

export const NavigationLabel = styled.div``

export const NavigationText = styled.span`
  font-size: ${rem('12px')};
  line-height: 1.5;
  /* conditionally adds margin on small using a prop */
  ${({ marginOnSmall }) =>
    marginOnSmall &&
    media.small`
        margin-top: 30px;
    `};
  ${props =>
    props.short &&
    `
      max-width: ${rem('200px')};
  `};
`

export const SocialIcons = 'height: 24px; width: 58px;'

export const TelephoneNumber = styled.span`
  color: ${white};
  font-family: 'Galano';
  font-size: ${rem('24px')};
  font-weight: 600;
  margin-top: 5px;
`

export const VeloeLogo = `fill: ${white}; height: 41px; width: 99px; margin-bottom: 15px;`

export const Logo = 'height: 30px; width: 74px;'



// WEBPACK FOOTER //
// ./src/app/elements/Footer/styles.js